import { WrapperMainTerms, WrapperContent } from './styles';
import { useEffect } from 'react';

interface IProps {
  setComponent: React.Dispatch<React.SetStateAction<string>>;
}

export const Terms: React.FC<IProps> = ({ setComponent }) => {
  useEffect(() => {
    const token = localStorage.getItem('LP-token');
    if (token === null) {
      setComponent('register');
    }
  }, []);

  return (
    <WrapperMainTerms id="simulation">
      <WrapperContent>
        <h1>Simulador de multas</h1>
        <p>
          Qualquer descumprimento da LGPD pode ser sancionado administrativamente pela Autoridade
          Nacional de Proteção de Dados (ANPD) após processo administrativo. Neste contexto, o
          Conselho Diretor da ANPD aprovou, por meio da Resolução CD/ANPD nº 4 de 24 de fevereiro de
          2023, o “Regulamento de Dosimetria e Aplicação de Sanções Administrativas”, que estabelece
          os parâmetros e critérios que serão adotados na aplicação de sanções pela Autoridade.{' '}
        </p>
        <p>
          Além de regulamentar a aplicação das sanções, o normativo traz, em um de seus anexos, a
          metodologia para o cálculo da multa simples.
        </p>
        <p>
          {' '}
          Seguindo esta metodologia, desenvolvemos o <strong>Simulador de Multa</strong>, por meio
          do qual você poderá estimar o valor da multa simples em diferentes cenários de infração.
          Basta acessar a plataforma e responder ao questionário.{' '}
        </p>
        <ul>
          <p>É importante notar que:</p>
          <li>O Simulador de Multas não é uma ferramenta oficial;</li>
          <li>Os resultados são gerados a partir das informações fornecidas no questionário;</li>
          <li>
            A interpretação dos critérios previstos na metodologia implica subjetividade do
            intérprete e pode ser feita de forma diversa pela Autoridade;
          </li>
          <li>
            Todos os dados coletados são confidenciais. Os dados pessoais (nome e e-mail) são
            utilizados para concessão de credenciais de acesso ao Simulador e, caso você deseje,
            para receber mais informações sobre Tecnologia e Proteção de Dados pessoais, de acordo
            com nossas Políticas.
          </li>
        </ul>
      </WrapperContent>
    </WrapperMainTerms>
  );
};
